import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import titleLeft from '../../../images/features/ana/title_left.png';
import titleRight from '../../../images/features/ana/title_right.png';
import CollaborateOtetsutabi from '../../../images/features/ana/Collaborate_Otetsutabi.png';
import { makeTransformStyles } from '../../core/styles';
import clsx from 'clsx';

const makePseudoImageStyles = (theme, smUp = {}) => ({
  content: "''",
  display: 'block',
  width: 34,
  height: 34,
  position: 'absolute',
  top: -40,
  [theme.breakpoints.up('sm')]: {
    top: '50%',
    ...makeTransformStyles('translateY(-50%)'),
    ...smUp,
  },
});

const useStyles = makeStyles((theme) => ({
  container: {
    textAlign: 'center',
  },
  containerTitle: {
    display: 'flex',
    justifyContent: 'center',
  },
  titleImage: {
    margin: '8px 0',
    width: 160,
    [theme.breakpoints.up('sm')]: {
      width: 177,
    },
  },
  title: {
    width: '100%',
    fontSize: 20,
    position: 'relative',
    display: 'flex',
    margin: '8px 0',
    fontWeight: 'bold',
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
      fontSize: 28,
    },
    '&::before': {
      ...makePseudoImageStyles(theme, { left: -50 }),
      backgroundImage: `url('${titleLeft}')`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      left: 10,
    },
    '&::after': {
      ...makePseudoImageStyles(theme, { right: -50 }),
      backgroundImage: `url('${titleRight}')`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      right: 10,
    },
  },
  stableTitle: {
    [theme.breakpoints.only('xs')]: {
      '&::before': {
        top: '50%',
        ...makeTransformStyles('translateY(-50%)'),
        left: 0,
      },
      '&::after': {
        top: '50%',
        ...makeTransformStyles('translateY(-50%)'),
        right: 0,
      },
    },
  },
  text: {
    display: 'block',
    verticalAlign: 'middle',
    [theme.breakpoints.up('sm')]: {
      display: 'inline',
    },
  },
}));

const Title = ({ texts, disableImage = false }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {!disableImage && (
        <img
          src={CollaborateOtetsutabi}
          alt="collaborate_otetsutabi"
          className={classes.titleImage}
        />
      )}
      <div className={classes.containerTitle}>
        <h2
          className={clsx(classes.title, disableImage && classes.stableTitle)}
        >
          <div style={{ margin: 'auto' }}>
            {texts.map((text, index) => (
              <span key={index} className={classes.text}>
                {text}
              </span>
            ))}
          </div>
        </h2>
      </div>
    </div>
  );
};

export default Title;
